import { compose } from 'redux';
import { connect } from 'react-redux';
import HandoffImage from '../../components/handoff/HandoffImage';
import * as handoff from '../../utils/handoff/element';
import { getSelectedElement } from '../../selectors/handoff';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    return {
        type: element.className,
        url: handoff.getElementThumbURL(element),
    };
}
export default compose(connect(mapStateToProps))(HandoffImage);
